/* eslint-disable no-case-declarations */
import React from 'react';

import calculateTime from 'src/helpers/calculateTime';

const CustomSummary = (prop) => {
  const { rows, columns, summary } = prop;

  const calculateStatusCount = (status) => {
    return rows.filter((row) => row.daStatus === status).length;
  };

  const calculatedSummary = summary.map((summaryItem) => {
    const { field, aggregates, countClassName = '' } = summaryItem;

    if (!field || !aggregates) {
      return null;
    }

    const column = columns.find((col) => col.field === field);
    if (!column) {
      return null;
    }

    const columnType = column.type || 'string';
    let columnValues = rows.map((row) => row[field]);
    if (field == 'availableStock' && rows[0]?.invId) {
      let seenPartNames = new Set();
      columnValues = rows.reduce((acc, row) => {
        if (!seenPartNames.has(row.partName)) {
          seenPartNames.add(row.partName);
          acc.push(row[field]);
        }
        return acc;
      }, []);
    }
    const summaryResult = {
      field,
      countClassName,
    };

    aggregates.forEach(({ aggregate, caption }) => {
      const wrap = (value) => <span className={summaryItem?.countClassName}>{value}</span>;

      switch (aggregate.toLowerCase()) {
        case 'count':
          summaryResult.count = (
            <>
              {caption} : {wrap(columnValues.length)}
            </>
          );
          break;

        case 'sum':
          const sum = columnValues.reduce((acc, value) => acc + value, 0).toLocaleString();
          summaryResult.sum = (
            <>
              {caption} : {wrap(sum)}
            </>
          );
          break;

        case 'min':
          if (columnType === 'timestamp') {
            const timestamps = columnValues.map((ts) => ts !== undefined && new Date(ts));
            const { min } = calculateTime(timestamps);

            summaryResult.min = (
              <>
                {caption} : {wrap(min)}
              </>
            );
          } else {
            summaryResult.min = (
              <>
                {caption} : {wrap(Math.min(...columnValues))}
              </>
            );
          }
          break;

        case 'max':
          if (columnType === 'timestamp') {
            const timestamps = columnValues.map((ts) => ts !== undefined && new Date(ts));
            const { max } = calculateTime(timestamps);

            summaryResult.max = (
              <>
                {caption} : {wrap(max)}
              </>
            );
          } else {
            summaryResult.max = (
              <>
                {caption} : {wrap(Math.max(...columnValues))}
              </>
            );
          }
          break;

        case 'statuscount': {
          summaryResult.statusCount = {
            'On-Boarding': wrap(calculateStatusCount('Onboarding')),
            'On-Boarded': wrap(calculateStatusCount('On Boarded')),
            'Off-Boarded': wrap(calculateStatusCount('Off Boarded')),
          };
          break;
        }

        case 'median': {
          const sorted = columnValues.slice().sort((a, b) => a - b);
          const mid = Math.floor(sorted.length / 2);

          const median =
            sorted.length % 2 === 0 ? (sorted[mid - 1] + sorted[mid]) / 2 : sorted[mid];

          summaryResult.median = (
            <>
              {caption} : {wrap(median)}
            </>
          );
          break;
        }

        default:
          break;
      }
    });

    return summaryResult;
  });

  return (
    <div className="mt-0 p-2 bg-dark-color">
      <div className="grid-footer-summary">
        {calculatedSummary.map((summaryItem) => (
          <div key={summaryItem.field} className={`align-self-start`}>
            <ul className="m-0 p-2 grid-footer-summary">
              {Object.entries(summaryItem)
                .filter(([key]) => key !== 'field' && key !== 'countClassName') // Exclude 'field' from displaying
                .map(([aggregate, value]) => (
                  <li className="p-1" key={aggregate}>
                    {value !== undefined
                      ? aggregate === 'statusCount'
                        ? Object.entries(value).map(([status, count], index, array) => (
                            <span key={status}>
                              {status} :{' '}
                              <span className={summaryItem?.countClassName}>{count}</span>
                              {index < array.length - 1 && (
                                <span className="me-2 ms-2 border-end"></span>
                              )}
                            </span>
                          ))
                        : value
                      : 'N/A'}
                  </li>
                ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CustomSummary;
